import { Form, FormikProvider, useFormik, Field, ErrorMessage } from 'formik'
import React, { useEffect, useState } from 'react'
import { Col, Container, Row, Table } from 'react-bootstrap'
import { CommonAxiosGet, CommonAxiosPut } from '../../CommonUtils/CommonAxios';
import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts';
import * as Yup from "yup";
import { config } from '../../CommonUtils/CommonURLS';

export default function InspLocationChange() {

    const [getInstData, setInstData] = useState([])

    const validationSchema = Yup.object({
        closureList: Yup.array().of(
            Yup.object({
                recommended: Yup.string().required("Required")
            })
        )
    });

    const formik = useFormik({
        initialValues: {
            closureList: [

            ]
        },
        enableReinitialize: true,
        validationSchema,
        onSubmit: (values) => {
            submitInspClosureInst(values)
        }
    });

    function getInspectionClosureDetails() {
        let url = config.url.FAC_URL + "getLocationDetails"
        CommonAxiosGet(url)
            .then((res) => {
                if (res && res.data.status === true) {
                    const data = res.data.data || [];
                    setInstData(data);

                    if (data.length > 0) {
                        formik.setValues({
                            closureList: data.map(item => ({
                                instCode: item.coll_code,
                                instName: item.inst_name,
                                currentLocation: item.inst_address || "",
                                proposedAddress: item.address_ofnew_location || "",
                                recommended: item.recommended_status || "",
                                sno: item.sno || "",
                            }))
                        });
                    }
                } else {
                    setInstData([]);
                    formik.setValues({ closureList: [] });
                }
            })
            .catch((e) => {
                console.error(e);
                setInstData([]);
                formik.setValues({ closureList: [] });
            })
    }


    function submitInspClosureInst(values) {
        let url = config.url.FAC_URL + "updateLocationDetails"
        const item = values.closureList[0];
        const payload = {
            sno: item.sno,
            recommendedStatus: item.recommended
        };
        CommonAxiosPut(url, payload)
            .then((res) => {
                console.log("Response:", res.data)
                if (res.data.scode === "01") {
                    successAlert2(res.data.sdesc)
                    getInspectionClosureDetails();
                } else {
                    failureAlert(res.data.sdesc)
                }
            })
            .catch((e) => {
                console.error(e)
                failureAlert("Something went wrong!")
            })
    }

    useEffect(() => {
        getInspectionClosureDetails();
    }, [])
    const allRecommended = getInstData.length > 0 &&
        getInstData.every(item => item.recommended_status !== null && item.recommended_status !== "");
    return (
        <Container fluid className="py-3">
            <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>
                    <h5 className="mb-3 innerheader-new text-success">
                        <span>Institution Location Change</span>
                    </h5>
                    <Row className="mt-4">
                        <Col xs={12}>
                            {getInstData.length === 0 ? (
                                <center className="text-danger mt-4 h5">
                                    ***** No Data Found *****
                                </center>
                            ) : (
                                <>
                                    <Table bordered responsive>
                                        <thead className='table-primary'>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Name Of The Institution</th>
                                                <th>Current Location</th>
                                                <th>Address Of Proposed Location</th>
                                                <th>Recommended (Yes/No)</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {getInstData.map((data, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{data.inst_name}</td>
                                                    <td>{data.inst_address}</td>
                                                    <td>{data.address_ofnew_location}</td>

                                                    <td className="text-center">
                                                        <div className="d-flex justify-content-center gap-3">
                                                            <label>
                                                                <Field
                                                                    type="radio"
                                                                    name={`closureList.${index}.recommended`}
                                                                    value="YES"
                                                                    disabled={!!getInstData[index]?.recommended_status}
                                                                /> YES
                                                            </label>

                                                            <label>
                                                                <Field
                                                                    type="radio"
                                                                    name={`closureList.${index}.recommended`}
                                                                    value="NO"
                                                                    disabled={!!getInstData[index]?.recommended_status}
                                                                /> NO
                                                            </label>
                                                        </div>

                                                        <ErrorMessage
                                                            name={`closureList.${index}.recommended`}
                                                            component="div"
                                                            className="text-danger small"
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>

                                    <Row className="mt-4">
                                        <Col xs={12} className="text-end">
                                            {allRecommended ? (
                                                <span className="fw-bold text-success">
                                                    Already Submitted
                                                </span>
                                            ) : (
                                                <button type="submit" className="btn btn-primary">
                                                    Submit
                                                </button>
                                            )}
                                        </Col>
                                    </Row>
                                </>
                            )}
                        </Col>
                    </Row>
                </Form>
            </FormikProvider>
        </Container>
    )
}